import { useContext } from "react";
import styled from "styled-components";
import { LoadingContext } from "../contexts/LoadingContext";
import { ReactComponent as InprogressIcon } from "../images/inprogress-icon.svg";
import { ReactComponent as FailIcon } from "../images/fail-icon.svg";
import { ReactComponent as CompleteIcon } from "../images/complete-icon.svg";
interface ISnackBar {
  addonCss?: any;
}
const SnackBar = ({ addonCss }: ISnackBar) => {
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  return (
    <SContainer
      style={addonCss}
      className={`${isLoading ? "movein" : "moveout"} ${isLoading?.status}`}
    >
      {isLoading?.status === "inprogress" ? (
        <InprogressIcon />
      ) : isLoading?.status === "fail" ? (
        <FailIcon />
      ) : (
        <CompleteIcon />
      )}
      <SLabel>{isLoading?.label}</SLabel>
      <SCloseIcon onClick={() => setIsLoading(undefined)}>X</SCloseIcon>
    </SContainer>
  );
};
export default SnackBar;
const SContainer = styled.div`
  border: 1px solid var(--color-border);
  border-left: 4px solid var(--color-primary);
  background: var(--color-surface);
  color: var(--color-text);
  font-weight: 500;
  box-shadow: var(--shadow-lg);
  border-radius: var(--radius-md);
  position: fixed;
  align-items: center;
  display: none;
  padding: 12px 16px;
  min-width: 280px;
  max-width: 420px;
  z-index: 50;

  &.complete {
    border-left-color: var(--color-success);
  }
  &.inprogress {
    border-left-color: var(--color-primary);
  }
  &.fail {
    border-left-color: var(--color-danger);
  }

  &.movein {
    display: flex;
    @keyframes movein {
      from {
        opacity: 0;
        transform: translateX(24px);
      }
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }
    animation-name: movein;
    animation-duration: 260ms;
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    right: 24px;
    top: 90px;
  }

  & > svg {
    width: 22px;
    height: 22px;
    flex-shrink: 0;
  }
`;
const SLabel = styled.div`
  margin: 0px 16px;
  flex: 1;
  font-size: 14px;
`;
const SCloseIcon = styled.div`
  cursor: pointer;
  color: var(--color-text-subtle);
  font-size: 12px;
  padding: 4px 8px;
  border-radius: var(--radius-xs);
  transition:
    background-color var(--transition),
    color var(--transition);
  &:hover {
    background-color: var(--color-surface-alt);
    color: var(--color-text);
  }
`;
